import { Box, Button, Link, SpaceBetween, Spinner } from '@amzn/awsui-components-core';
import { Publication, UserType } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import { AppContext } from '../../../contexts/AppContext';

interface Props {
  releaseNotes: Publication[];
  isLoading?: boolean;
}

const ReleaseNoteList = (props: Props) => {
  const appContext = useContext(AppContext);
  const { releaseNotes, isLoading } = props;

  const joinSlackButton =
    appContext.authnInfo?.userProfile?.type === UserType.AWS ? (
      <Box color="text-body-secondary" fontWeight="bold">
        <Button
          iconUrl={'/images/slack_logo.svg'}
          iconAlt="Slack logo"
          variant="icon"
          ariaLabel="Join Slack channel"
          href={'https://amzn-aws.slack.com/archives/C017N8C00M8'}
        />
        Join us on Slack at{' '}
        <Link href={'https://amzn-aws.slack.com/archives/C017N8C00M8'}>#apg</Link>
      </Box>
    ) : null;

  return !!isLoading ? (
    <Spinner />
  ) : (
    <SpaceBetween direction="vertical" size="s">
      <Box variant="h2">Release notes</Box>
      <div>
        {releaseNotes.map((rn) => (
          <Box variant="p" key={rn.contentId}>
            <Link variant="secondary" href={`/post-viewer/${rn.contentId}`}>
              {rn.contentMetadata.contentName}
            </Link>
          </Box>
        ))}
      </div>
      <hr />
      {joinSlackButton}
    </SpaceBetween>
  );
};

export default ReleaseNoteList;
